export default {"src":"/_next/static/media/plus-small-icon.f12a060c.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};